module.exports = __webpack_public_path__ + "img/display_bg.dae33163.png";